//
//
//
//
//
//
//
//
//
//
//
//

import Question from '../_question'
import Answer from '../_answer'
import Service from '@/service/verify_qualification'
const STATUS = {
    QUESTION: 1,
    ANSWER: 2
}
export default {
    components: {
        Question,
        Answer
    },
    data () {
        return {
            loading: true,
            status: STATUS.QUESTION,
            type: '',
            question: {},
            answer: '',
            answered: [],
            doc: ''
        }
    },
    mounted () {
        this.reset()
        this.type = this.$route.query.type
        this.getQuestion()
    },
    methods: {
        backHome () {
            this.answered = []
            this.question = {}
            this.$router.back()
        },
        cancelAnswer (index) {
            this.answered.splice(index)
            const pre = index - 1
            let id = ''
            if (pre >= 0) {
                id = this.answered[pre].id
            }
            this.getQuestion(id)
        },
        getQuestion (id = '', new_answer) {
            Service.getQuestion(this.type, id).then((data) => {
                if (data.finish) {
                    this.showAnswer(data.result)
                    this.doc = data.doc_url
                } else {
                    this.question = data
                }
                new_answer && this.answered.push(new_answer)
                this.loading = false
            })
        },
        showAnswer (answer) {
            this.answer = answer
            this.status = STATUS.ANSWER
        },
        reset () {
            this.status = STATUS.QUESTION
            this.answer = ''
            this.answered = []
            this.question = {}
        }
    },
}
